import { CLIMATE_DEALS } from '../sharedConfig';

// budgetAllocation values are relative weights, NOT percentages.
// The formula (weight / sumOfSelectedWeights) × sourceBudget distributes 100%
// of the source line item's budget across whichever items are enabled.
export default {
  key: 'greenEnergy',
  label: 'Green Energy Display Strategy',
  strategySets: {
    default: {
      label: 'Standard (5 items)',
      lineItems: [
        { name: 'CPM_BT_RenewableEnergy_Interest_25to54-Male-HHITop25_DIS_Prospecting', segment: 'RENEWABLE_ENERGY', budgetAllocation: 45 },
        { name: 'CPM_BT_ElectricHybridVehicles_Interest_25to54-Male-HHITop25_DIS_Prospecting', segment: 'ELECTRIC_HYBRID_VEHICLES', budgetAllocation: 45 },
        { name: 'CPM_CT_ElectricHybridVehicles_x_25to54-Male-HHITop25_DIS_Prospecting', segment: 'MALE_25_54_HHI_TOP_25', budgetAllocation: 5, contextualTarget: { name: 'Electric/Hybrid Vehicles Content (5)', listId: '1639329385' } },
        { name: 'CPM_CT_TopKeywords_x_25to54-Male-HHITop25_DIS_Prospecting', segment: 'MALE_25_54_HHI_TOP_25', budgetAllocation: 3, contextualTarget: { name: 'Chesapeake Key Word Cloud KW List', listId: '1163742484' } },
        { name: 'CPM_CT_GreenEnergy_x_25to54-Male-HHITop25_DIS_Prospecting', segment: 'MALE_25_54_HHI_TOP_25', budgetAllocation: 2, contextualTarget: { name: 'Green Energy (1)', listId: '1639330212' } },
      ],
    },
  },
  deals: CLIMATE_DEALS,
};
